"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackRegisterClick = void 0;
const enums_1 = require("../enums");
const trackAnalyticsEvent_1 = require("./trackAnalyticsEvent");
function trackRegisterClick(category) {
    (0, trackAnalyticsEvent_1.trackAnalyticsEvent)({
        category,
        action: enums_1.EventAction.TextClick,
        label: 'Register',
        nonInteraction: false,
        eventData: {
            eventName: enums_1.GA4EventName.ClickTextLink,
            feature_category: enums_1.GA4FeatureCategory.Wishlist,
            click_element: 'Register',
            click_text: 'Registrieren',
        },
    });
}
exports.trackRegisterClick = trackRegisterClick;
//# sourceMappingURL=trackRegisterClick.js.map